import { SanityImageSource } from '@sanity/image-url/lib/types/types'

import { ParagraphSmall } from 'src/components/atoms/DesignSystem/Typography/Typography'
import { SanityImage } from 'src/components/atoms/SanityImage'
import { Heading1, Subtitle } from 'src/components/atoms/Typography'
import { Breadcrumbs } from 'src/components/layouts/Breadcrumbs'
import { Text, TextValue } from 'src/components/molecules/sanity/Content'

type PostHeroProps = {
  title: string
  postDate?: string | null
  readingTime: string
  imageUrl: SanityImageSource | undefined
  summary?: TextValue
}

export const PostHero = ({
  imageUrl,
  postDate,
  readingTime,
  title,
  summary
}: PostHeroProps) => {
  return (
    <>
      <div className='bg-aquaSpring'>
        <Breadcrumbs />
      </div>
      <div className='bg-aquaSpring '>
        <div className='container mx-auto px-5 md:pt-5 pt-2'>
          <Heading1 className='leading-[100%]'>{title}</Heading1>
          {summary ? (
            <Subtitle>
              <Text value={summary} />
            </Subtitle>
          ) : null}
          <ParagraphSmall className='!mt-2 !md:mt-5'>
            {postDate ? `${postDate} | ${readingTime}` : readingTime}
          </ParagraphSmall>
        </div>
      </div>
      <div className='md:pt-10 px-5 pt-5 bg-[linear-gradient(to_bottom,_#e7f1e5_50%,_transparent_50%)]'>
        <div className='container mx-auto overflow-clip'>
          <SanityImage
            source={imageUrl}
            sourceWidth={1280}
            sourceHeight={470}
            alt={title}
            width={1280}
            height={470}
            className=' rounded-[10px]'
          />
        </div>
      </div>
    </>
  )
}
